import styles from './accept-cookies.module.scss';
import { useTranslation } from 'next-i18next';
import {useEffect, useState} from "react";

const AcceptCookies = () => {
    const { t } = useTranslation(['common']);
    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        checkConsent();
    }, []);

    const acceptCookies = () => {
        localStorage?.setItem('accept_cookies', 'true');
        checkConsent();
    };

    const checkConsent = () => {
        const hasAccepted = localStorage?.getItem('accept_cookies');
        setIsShown(!hasAccepted);
    };

    if (!isShown) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <p className={styles.text}>
                    {t(`Сайт использует сооkіе, что позволяет получать информацию о вас. Это нужно, чтобы улучшать сайт. Продолжая
            пользоваться сайтом, вы соглашаетесь с использованием cookie и предоставлением их сторонним партнерам. Вам
            нужно принять это, либо покинуть сайт. `)}
                    <a href="/privacy-policy" target="_blank">
                        {t('Политика конфиденциальности')}
                    </a>
                </p>

                <button className={styles.button} onClick={acceptCookies}>
                    {t('Принять')}
                </button>
            </div>
        </div>
    );
};

export default AcceptCookies;
